/**
 * Custom useUndoToast Hook
 * Provides easy access to the "undo last mark-done" state and actions
 * Follows the Four-Layer Rule: Components → Hooks → Stores → Services
 */

import { useAppStore } from '../stores';

export function useUndoToast() {
  const undoableCompletion = useAppStore(state => state.chores.undoableCompletion);
  const undoMarkChoreDone = useAppStore(state => state.chores.undoMarkChoreDone);
  const dismissUndoableCompletion = useAppStore(state => state.chores.dismissUndoableCompletion);

  return {
    undoableCompletion,
    undoMarkChoreDone,
    dismissUndoableCompletion,
  };
}
